module.exports = __webpack_public_path__ + "static/img/模型.57dbf29.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Help/模型.gif
// module id = 3qkx
// module chunks = 3